import React from "react";
import { Intent, Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { generatePath } from "react-router";
import { NavLink } from "react-router-dom";
import { IEFormsTemplateLight } from "../../stores/formsStore";
import { publicRoutes } from "../../routePaths";


interface IProps {
  tiid: string;
  templates: IEFormsTemplateLight[];
  locationId: string;
}


const itemStyle = { padding: '0.5em 0' };

const PublicFormList: React.FC<IProps> = ({ tiid, templates, locationId }) => {
  const icon = <Icon icon={IconNames.DOT} intent={Intent.NONE} style={{ paddingRight: '1em', opacity: '0.3' }} />
  const links = templates.map(t => {

    const url = generatePath(publicRoutes.forms.view, { tiid, templateId: t.RecordId, locationId });

    return <div key={t.RecordId} style={itemStyle} >{icon}<NavLink to={url}>{t.TemplateName}</NavLink></div>

  });

  return (
    <ul>
      {links}
    </ul>
  )
}

export default PublicFormList;
